/**
 * Offre d'accueil des nouveaux abonnés et contact support, partagés par le chatbot et les
 * infobulles « Le saviez-vous ? ». FREE_TRIAL_MONTHS à 0 retire toute mention de l'essai gratuit.
 */
export const SUPPORT_EMAIL = 'contact@assiganto-agro.com';
export const FREE_TRIAL_MONTHS = 6;
export const FREE_TRIAL_PARCELS = 2;
